<ui-title [title]="'Reassign Reports'"></ui-title>

<p *ngIf="reassign.noOpenReport" class="alert alert-warning">
	No Open Reporting Quarter. No Pending Reports available to be reassigned
</p>

<ui-loading [loadingText]="'loading report'" [loading]="reassign.loading"></ui-loading>

<ui-alert
	*ngIf="reassign.modalConfirm.display"
	[title]="reassign.modalConfirm.title"
	[text]="reassign.modalConfirm.text"
	(onAction)="reassign.modalConfirm.cb($event)"
	[confirm]="true"
></ui-alert>
<ui-alert
	*ngIf="reassign.modalAlert.display"
	[title]="reassign.modalAlert.title"
	[text]="reassign.modalAlert.text"
	(onAction)="reassign.modalAlert.cb($event)"
></ui-alert>

<div *ngIf="!reassign.loading && !reassign.noOpenReport">
	<div class="col-lg-6">
		<div class="card">
			<div class="card-header">Current Report</div>
			<div class="card-body">
				<table class="table table-sm mb-0"
				>
					<tr>
						<th>Period</th>
						<th>Status</th>
						<th>Date Opened</th>
					</tr>
					<tr>
						<td>{{reassign.report.Name}} {{reassign.report.Year}}</td>
						<td class="helper-capitalize">{{reassign.report.StatusId}}</td>
						<td>{{reassign.report.CreatedDate|date}}</td>
					</tr>
				</table>
			</div>
		</div>
	</div>

	<div class="col-lg-12 mt-4" *ngIf="!reassign.loading">

		<ui-table
			[filters]="true"
			[options]="reassign.tableOptions"
			[chunker]="reassign.chunker" (chunked)="reassign.chunkedData = $event"
			[headers]="reassign.tableHeaders"
			#table
		>
			<tr *ngFor="let d of reassign.chunkedData"
			>
				<td style="width:25px">
					<input type="checkbox" name="reassign[{{d.Id}}]" [(ngModel)]="reassign.checked[d.Id]"
						   [checked]="reassign.checked[d.Id]"
						   *ngIf="d.StatusId=='pending' && !d.SORUserOverridenApproverId"
						   class="btn btn-primary btn-sm"
					>
				</td>
				<td>{{d.SORUserApprover.FirstName}}</td>
				<td>{{d.SORUserApprover.LastName}}</td>
				<td>{{d.SORUserOverridenApprover?.FirstName}}</td>
				<td>{{d.SORUserOverridenApprover?.LastName}}</td>
				<td class="helper-capitalize">{{d.StatusId}}</td>
				<td>
					<ui-loading *ngIf="reassign.reassigning[d.Id]"></ui-loading>
					<button *ngIf="d.SORUserOverridenApproverId && d.StatusId=='pending' && !reassign.reassigning[d.Id]" class="btn btn-danger btn-sm" (click)="reassign_unassign(d)" style="    height: 20px;
    line-height: 10px;">unassign
					</button>
				</td>
			</tr>
		</ui-table>

		<div class="col-lg-6" style="    padding: 0;margin-top: 20px;">
			<div class="card">
				<div class="card-body mat-autocomplete-large">

					<mat-form-field>
						<input [formControl]="reassign.sorUserIdFormControl" type="text" placeholder="Search new approver" aria-label="Number" matInput [matAutocomplete]="auto">

						<mat-autocomplete panelWidth="'100%'" autoActiveFirstOption #auto="matAutocomplete" [displayWith]="autocompleteDisplayUser">
							<mat-option *ngFor="let item of  reassign.autocomplete$ | async; let index=index" [value]="item">
								{{item.FirstName}} {{item.LastName}} ({{item.Login}})
							</mat-option>
						</mat-autocomplete>
					</mat-form-field>
					<br/>
					<button class="btn btn-primary" [disabled]="!reassign_hasSelection()" (click)="reassign_doReassign()">Reassign Selected</button>
				</div>
			</div>
		</div>

	</div>
</div>
